import type { RegisterRouteFunction, RouterOptions } from 'owa-router';
import type { Dispatch, Store } from 'redux';
import { getAppState, importContactsDeeplinkNavigated, setRoute } from 'people/lib/appstate';
import {
    groupFolderRouteActionHandler,
    groupRouteActionHandler,
    GroupFolderKey,
    GroupKey,
} from 'people/lib/hub';
import { isGroupsEnabled } from 'owa-account-capabilities/lib/isGroupsEnabled';

const deeplinkImportRoute = 'import';
const peopleAppName = 'people';

export function getRouterOptions(store: Store<{}>): RouterOptions {
    return {
        routeGenerator: Promise.resolve(() => getCurrentRoute(store)),
        vdir: peopleAppName,
        defaultRoute: '/',
        registerRoutes: (registerRoute: RegisterRouteFunction) =>
            initializeRoutes(store.dispatch, registerRoute),
    };
}

function initializeRoutes(
    dispatch: Dispatch,
    registerPeopleRoute: RegisterRouteFunction
): Promise<void> {
    registerPeopleRoute('', () => {
        setRoute(dispatch)(peopleAppName);
    });
    registerPeopleRoute(`/${deeplinkImportRoute}`, () => {
        importContactsDeeplinkNavigated(dispatch)();
    });

    if (isGroupsEnabled()) {
        registerPeopleRoute('/group', (params: GroupFolderKey) => {
            groupFolderRouteActionHandler(dispatch, params);
        });
        registerPeopleRoute('/group/:groupFolder', (params: GroupFolderKey) => {
            groupFolderRouteActionHandler(dispatch, params);
        });
        registerPeopleRoute('/group/:groupDomain/:groupAlias', (params: GroupKey) => {
            groupRouteActionHandler(dispatch, params);
        });
        registerPeopleRoute('/group/:groupDomain/:groupAlias/:tabName', (params: GroupKey) => {
            groupRouteActionHandler(dispatch, params);
        });
    }
    return Promise.resolve();
}

function getCurrentRoute(store: Store): string[] {
    let navigationState = getAppState(store.getState()).view.navigationState;
    const route: string[] = [];
    const routeSegements = navigationState.currentRouteList || [''];

    route.push(...routeSegements);
    return route;
}
